import { AlertTriangle } from "lucide-react";

export function Disclaimer({ compact }) {
  return (
    <div data-testid="disclaimer" className="pm-card p-3 flex gap-2 items-start"
      style={{ borderColor: "var(--border-subtle)", background: "var(--surface-subtle)" }}>
      <AlertTriangle className="w-4 h-4 mt-0.5 shrink-0" style={{ color: "var(--cost)" }} />
      <p className="text-xs leading-relaxed" style={{ color: "var(--text-2)" }}>
        {compact
          ? "Education and planning only. Not financial, legal, tax, or contractor advice. Dollar figures are rough local ranges."
          : "Education and planning only. Not financial, legal, tax, or contractor advice. Measurements and dollar figures are rough local ranges. Licenses depend on location — confirm official sources. Location is used only to tailor suggestions and is not required if you type a city."}
      </p>
    </div>
  );
}

export function TypeBadge({ type }) {
  const map = { Time: "var(--earn)", Money: "var(--cost)", Both: "var(--text)" };
  return <span className="badge" style={{ background: map[type] || "var(--text)" }} data-testid={`type-badge-${type}`}>{type}</span>;
}

export function FitBadge({ fit }) {
  const map = { Good: "var(--earn)", Tight: "var(--cost)", Poor: "var(--warning)" };
  return <span className="label-mono" style={{ color: map[fit] || "var(--text-2)" }}>Fit: {fit}</span>;
}
